/** The Foodics BI mark and name, as on the sign-in pages. */
export function BrandMark() {
  return (
    <div className="flex items-center gap-2 text-sm font-label">
      <span className="grid size-7 place-items-center rounded-lg bg-primary">
        <svg viewBox="0 0 16 16" className="size-4 fill-primary-foreground" aria-hidden="true">
          <rect x="2" y="7" width="3" height="7" rx="1" />
          <rect x="6.5" y="2" width="3" height="12" rx="1" />
          <rect x="11" y="5" width="3" height="9" rx="1" />
        </svg>
      </span>
      Foodics BI
    </div>
  );
}
